export default [
  {
    path: "survey-questions",
    meta: { label: "Survey Questions" },
    component: {
      render(c) {
        return c("router-view");
      }
    },
    children: [
      {
        path: "",
        name: "survey-questions",
        meta: {
          label: "Questions",
          permission: "show_all_survey_question"
        },
        component: () =>
          import("../../../views/surveysettings/questions/index.vue")
      },
      {
        path: "create",
        name: "CreateSurveyQuestion",
        meta: {
          label: "Create Survey Question",
          permission: "create_survey_question"
        },
        component: () =>
          import("../../../views/surveysettings/questions/create.vue")
      },
      {
        path: ":id",
        name: "ShowSurveyQuestion",
        meta: {
          label: "Show Survey Question",
          permission: "show_single_survey_question"
        },
        component: () =>
          import("../../../views/surveysettings/questions/show.vue")
      },
      {
        path: ":id/edit",
        name: "EditSurveyQuestion",
        meta: {
          label: "Edit Survey Question",
          permission: "edit_survey_question"
        },
        component: () =>
          import("../../../views/surveysettings/questions/edit.vue")
      }
    ]
  },
  {
    path: "survey",
    meta: { label: "Survey" },
    component: {
      render(c) {
        return c("router-view");
      }
    },
    children: [
      {
        path: "",
        name: "survey",
        meta: {
          label: "Surveys",
          permission: "show_all_survey"
        },
        component: () =>
          import("../../../views/surveysettings/headers/index.vue")
      },
      {
        path: "my-surveys",
        name: "MySurveys",
        meta: {
          label: "My Surveys",
        },
        component: () =>
          import("../../../views/surveysettings/headers/widget.vue")
      },
      {
        path: "create",
        name: "CreateSurvey",
        meta: {
          label: "Create Survey",
          permission: "create_survey"
        },
        component: () =>
          import("../../../views/surveysettings/headers/create.vue")
      },
      {
        path: ":id/take",
        name: "TakeSettingsSurvey",
        meta: {
          label: "Take Survey",
          permission: "show_single_survey"
        },
        component: () =>
          import("../../../views/surveysettings/headers/take.vue")
      },
      {
        path: ":id",
        name: "ShowSurvey",
        meta: {
          label: "Show Survey",
          permission: "show_single_survey"
        },
        component: () =>
          import("../../../views/surveysettings/headers/show.vue")
      },
      {
        path: ":id/edit",
        name: "EditSurvey",
        meta: {
          label: "Edit Survey",
          permission: "edit_survey"
        },
        component: () =>
          import("../../../views/surveysettings/headers/edit.vue")
      }
    ]
  }
];
